import React from 'react';
import { useDataValue } from 'globals/contexts/dataContext';

import { useHistory } from 'react-router-dom';
import { Link, generatePath } from 'react-router-dom';
import routes from 'globals/routes';
import './landingSection.css';
import './landingSectionMobile.css';

const LandingSection = ({filters, content: pageContent}) => {
  // const  = props['content'];
  const [{content, currentLanguage}, dispatch] = useDataValue();
  const logoUrl = content['logo'];
  const history = useHistory();
  const setCurrentEvent = (eventIdx) => {
    history.push(generatePath(routes.eventPage, {
      eventname: eventIdx,
      lang: currentLanguage
    }));
  }
  return <section className="landing" id="landing">
    <div className="logo">
      <Link to={generatePath(routes.indexPage, {lang: currentLanguage})}>
        <img src={logoUrl} />
      </Link>
    </div>
    <div className="contentWrapper">
      <div className="textContent">
        <div className="titleWrapper">
          <div className="title" dangerouslySetInnerHTML={{
            __html: (pageContent['title'])
          }} />
          <div className="brief" dangerouslySetInnerHTML={{
            __html: (pageContent['brief'])
          }} />
        </div>
        <div className="eventBox">
          <div className="contentBox">
            <div dangerouslySetInnerHTML={{
              __html: (pageContent['introductions'] && pageContent['introductions']['length'])? pageContent['introductions'][0]['text']: ''
            }} />
            {pageContent['buttonText'] && <button class="detailsBtn" onClick={() => setCurrentEvent(pageContent['eventtitle'])}>{pageContent['buttonText']}</button>}
          </div>
          <div className="seperator"></div>
          <div className="introductions">
            {pageContent['introductions'].map(content => {
              return <div key={content['language']} 
                className={`introduction verticalText ${content['language']}`}
                dangerouslySetInnerHTML={{
                  __html: pageContent['eventtitle']
                }} />;
            })}
          </div>
          <div className="date">
            <div className="month verticalText zh">{pageContent['month'][0]}</div>
            <div className="month verticalText en">{pageContent['month'][1]}</div>
          </div>
        </div>
      </div>
      <div className="imageContent">
        <img src={pageContent['mainImage']} />
      </div>
    </div>
  </section>;
}

export default LandingSection;